import { render, staticRenderFns } from "./underReview.vue?vue&type=template&id=6e3c7352&scoped=true&"
import script from "./underReview.vue?vue&type=script&lang=js&"
export * from "./underReview.vue?vue&type=script&lang=js&"
import style0 from "./underReview.vue?vue&type=style&index=0&id=6e3c7352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c7352",
  null
  
)

export default component.exports